var _defs, _path, _path2, _rect, _path3, _rect2, _path4;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgActionsduringExecution(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32.74 32.7",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#fff;}"))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "EN 1991-1-6") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M-938.39,280.59a12.75,12.75,0,0,1-1.6-.15v7.32a4.53,4.53,0,0,0,4.54,4.51,4.53,4.53,0,0,0,4.54-4.51v-6.89l-0.79-.27h-6.69Zm0,0",
    transform: "translate(944.99 -259.56)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M-912.25,272.06a4.19,4.19,0,0,0-2.87-4V276a4.19,4.19,0,0,0,2.87-4h0Zm0,0",
    transform: "translate(944.99 -259.56)"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    fill: "currentColor",
    x: 10.52,
    y: 4.59,
    width: 1.57,
    height: 14.6
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M-939.89,264.3c-1.69.25-4,.73-4.34,0.8a1,1,0,0,0-.76.94v10.8a1,1,0,0,0,.76.94c0.34,0.07,2.66.55,4.34,0.8V264.3h0Zm0,0",
    transform: "translate(944.99 -259.56)"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    fill: "currentColor",
    x: 7.02,
    y: 4.59,
    width: 1.57,
    height: 14.6
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M-918.25,259.61L-931,264v14.88l12.73,4.39a1,1,0,0,0,1.27-.91V260.52a1,1,0,0,0-1.27-.91h0Zm0,0",
    transform: "translate(944.99 -259.56)"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgActionsduringExecution);
export default __webpack_public_path__ + "static/media/Actions during Execution.7636dfe2.svg";
export { ForwardRef as ReactComponent };